import * as React from 'react';
import type { LiveChatProps } from '~/Partials/LiveChat/LiveChat';
import { loadLiveChatComponent } from '~/Partials/LiveChat/Utils/utilsLiveChat.client';
import { LazyComponent } from '~/Utils/Lazy/LazyComponent';

export const LazyLiveChat: React.FC<LiveChatProps> = props => (
    <LazyComponent<LiveChatProps> importComponentMethod={loadLiveChatComponent} componentProps={props} />
);
